var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcLecheenpolvoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeb0b0;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.49,20.6A3.36,3.36,0,0,0,10.17,24V48.31a3.36,3.36,0,0,0,3.32,3.35h17.3a3.35,3.35,0,0,0,3.32-3.35V24a3.35,3.35,0,0,0-3.32-3.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.51,8.34a1.28,1.28,0,0,0-1.26,1.49c.25,1.48.51,3.31.89,4.88a10.33,10.33,0,0,0,.71,2.14,2.57,2.57,0,0,0,1.66,1.58h0a1.63,1.63,0,0,0,.31,0h5.61A2,2,0,0,0,25,17.6a8.15,8.15,0,0,0,.89-1.26c.39-.64.75-1.33,1.06-1.91l20.1,0h0a2.7,2.7,0,0,0,2.08-1.06,3.4,3.4,0,0,0,.64-1.93,3.16,3.16,0,0,0-.53-2,2.67,2.67,0,0,0-2.13-1.1H15.51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcLecheenpolvoGray);
export default __webpack_public_path__ + "static/media/DC__Leche en polvo_gray.d6642a81140364d7648a3f05dcbd0724.svg";
export { ForwardRef as ReactComponent };